import React, { useState, useEffect } from 'react';
import { NAV_LINKS } from '../data';

const NavBar = ({ dark, setDark, t }) => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0,
        zIndex: 1000,
        background: scrolled
          ? dark ? 'rgba(8,8,8,0.97)' : 'rgba(255,255,255,0.97)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(24px)' : 'none',
        borderBottom: scrolled ? `1px solid ${t.border}` : 'none',
        boxShadow: scrolled
          ? dark ? '0 4px 40px rgba(0,0,0,0.5)' : '0 4px 40px rgba(0,0,0,0.08)'
          : 'none',
        transition: 'all 0.4s cubic-bezier(.4,0,.2,1)',
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          padding: '0 32px',
          height: 76,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Logo / Brand */}
        <a href="#home" style={{ textDecoration: 'none' }}>
          <span
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              fontWeight: 700,
              fontSize: 22,
              color: t.gold,
              letterSpacing: 0.5,
            }}
          >
<img src="/logo.png" alt="Future Fund Finance" style={{ height: 85, width: 130 }} />          </span>
        </a>

        {/* Desktop Nav */}
        <div className="nav-links" style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
          {NAV_LINKS.map((link) => (
            <a
              key={link}
              href={`#${link.toLowerCase()}`}
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 500,
                fontSize: 14,
                color: t.textSub,
                textDecoration: 'none',
                transition: 'color 0.25s',
              }}
              onMouseEnter={(e) => (e.target.style.color = t.gold)}
              onMouseLeave={(e) => (e.target.style.color = t.textSub)}
            >
              {link}
            </a>
          ))}
        </div>

        {/* Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {/* Theme Toggle */}
          <button
            onClick={() => setDark((d) => !d)}
            style={{
              background: t.goldDim,
              border: `1px solid ${t.border}`,
              borderRadius: 40,
              cursor: 'pointer',
              padding: '8px 16px',
              color: t.gold,
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 500,
              fontSize: 13,
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              transition: 'all 0.3s',
            }}
          >
            {dark ? '☀️ Light' : '🌙 Dark'}
          </button>

          {/* CTA */}
          <a
            href="#contact"
            style={{
              background: 'linear-gradient(135deg,#c9a227,#e8c040)',
              color: '#0a0a0a',
              padding: '10px 24px',
              borderRadius: 8,
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 700,
              fontSize: 14,
              textDecoration: 'none',
              boxShadow: '0 4px 20px rgba(201,162,39,0.4)',
              transition: 'all 0.3s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-1px)';
              e.currentTarget.style.boxShadow = '0 8px 28px rgba(201,162,39,0.55)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = '';
              e.currentTarget.style.boxShadow = '0 4px 20px rgba(201,162,39,0.4)';
            }}
          >
            Apply Now
          </a>

          {/* Hamburger */}
          <button
            className="mobile-btn"
            onClick={() => setMobileOpen((o) => !o)}
            style={{
              display: 'none',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              fontSize: 24,
              color: t.gold,
            }}
          >
            {mobileOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div
          style={{
            background: dark ? 'rgba(8,8,8,0.99)' : 'rgba(255,255,255,0.99)',
            borderTop: `1px solid ${t.border}`,
            padding: '16px 32px 28px',
          }}
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link}
              href={`#${link.toLowerCase()}`}
              onClick={() => setMobileOpen(false)}
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontWeight: 500,
                fontSize: 16,
                color: t.text,
                textDecoration: 'none',
                padding: '12px 0',
                borderBottom: `1px solid ${t.border}`,
                display: 'block',
              }}
            >
              {link}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
};

export default NavBar;
